export default "__VITE_ASSET__HdHosaId__"